import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { PRODUCTS } from 'src/app/shared/constants/common-constants';
// import { PRODUCTS } from 'src/app/shared/constants/common-constants';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { CompanyService } from 'src/app/shared/services/node-api/company.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';

@Component({
  selector: 'app-industry-report-details-component',
  templateUrl: './industry-report-details-component.component.html',
  styleUrls: ['./industry-report-details-component.component.scss'],
})
export class IndustryReportDetailsComponentComponent implements OnInit {
  companyOverview: any;
  productList: any;
  isAddedInFollowList: any;
  PRODUCTS = PRODUCTS;
  cin: string;
  companyName;
  productName;
  productType: string;
  // PRODUCTS = PRODUCTS;
  sku: string;
  productDetails: any;
  loginEmail;
  plan;
  isAdvance;
  isPremium;
  isFree;
  pdfURL;
  pdfSampleURL;
  isSampleReportVisible = false;
  company_url;
  isProduct: boolean;
  isReportVisible: boolean = false;
  deviceType: string;


  constructor(
    private companyService: CompanyService,
    private commonService: CommonService,
    private route: ActivatedRoute,
    private localStorage: LocalStorageService,
    private loginSignupService: LoginSignupService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) {
    this.deviceType = localStorage.getItem('deviceType');
    this.route.params.subscribe((params) => {
      this.companyName = params.name;
      this.productName = params.report;
      this.isReportVisible =this.parseBoolean(params.isReportVisible);;
      this.isSampleReportVisible = this.parseBoolean(params.isSampleReportVisible);;
      this.cin = this.localStorage.getItem(this.companyName);
      this.sku = params.sku.toUpperCase();
      this.productType = this.commonService.getProductTypeBySku(this.sku);
      this.productDetails = this.commonService.getProductDetailsByType(
        this.productType
      );
      this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
      this.plan = this.localStorage.getItem('plan');
      if (this.plan == 'plan_advance') {
        this.isAdvance = true;
      }else if (this.plan == 'plan_premium') {
        this.isPremium = true;
      }else{
        this.isFree = true
      }
      this.isProductFree(this.plan);
      this.pdfURL = this.commonService.getProductUrlBySku(this.sku);
      this.pdfSampleURL = this.commonService.getProductSampleUrlBySku(this.sku);

      this.company_url = params.name.toLowerCase();
      this.company_url = this.company_url.replaceAll(' ', '-');
    });
  }

  private parseBoolean(value: string): boolean {
    return value === 'true';
  }

  isProductFree(plan) {
    this.isProduct = false;
    if (this.loginEmail == undefined || this.loginEmail == '' || this.loginEmail == null) {
      this.isProduct = false;
    } else {
      if (plan == "plan_premium") {
        this.isProduct = true;
      } else if (plan == "plan_advance") {
        if (this.productType == 'BSS' ||
          this.productType == 'PLS' ||
          this.productType == 'ROC' ||
          this.productType == 'SHS' ||
          this.productType == 'FRO') {
          this.isProduct = false;
        } else {
          this.isProduct = true;
        }
      } else {
        this.isProduct = false;
      }
    }
  }

  ngOnInit(): void {
    this.companyService.sharedData$.subscribe((data) => {
      if (data) {
        this.companyOverview = data;
        this.productList = data.product_list;
        this.isAddedInFollowList = this.commonService.isInFollowlist(
          this.companyOverview._id
        );
      }
    });
  }

  showReport(){
    this.isReportVisible = true
    this.router.navigate([
      '/company/' +
        this.company_url +
        '/product/' +
        this.productName +
        '/' +
        this.sku + '/' + this.isReportVisible,,
    ]);
  }

  showSampleReport() {
    this.isSampleReportVisible = !this.isSampleReportVisible;
    this.router.navigate([
      '/company/' +
        this.company_url +
        '/sample/' +
        this.productName +
        '/' +
        this.sku + '/' + this.isSampleReportVisible,
    ]);
  }

  getSanitizedSvg(svgIcon: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(svgIcon);
  }
}
